<template>
  <div class="ts-flex">
    <div class="ts-relative ts-w-full">
      <input
        v-model.trim="serialNumber"
        ref="search"
        type="text"
        class="
          ts-w-full
          ts-border
          ts-float-right
          ts-px-2
          ts-py-1
          ts-rounded
          ts-outline-none
          ts-pr-6
        "
        :placeholder="$t('wholesale.serialOnly')"
      />
      <span
        class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2"
        style="margin-top: 7px"
      >
        <i class="fa fa-search" v-if="!searching"></i>
        <i class="fas fa-circle-notch d-inline-block spin" v-else></i>
      </span>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'autoAddAfterSearchSerial',
  props: ['value'],
  data() {
    return {
      serialNumber: '',
      searching: false,
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapGetters('wholesale/operation', [
      'isDefaultUom',
      'getSalePrice',
      'getFreeItemBuyItem'
    ]),
    khrRate() {
      let foundFx = this.$store.state.wholesale.operation.exchangeRate.find(
        e => e.to_currency == 'KHR'
      )
      if (foundFx) {
        return (this.model.fx_rate_khr = parseFloat(foundFx.fx_rate))
      }
      return 4000
    }
  },
  methods: {
    ...mapActions('wholesale/operation', ['findSerial']),
    fetchSerial() {
      this.searching = true
      this.findSerial(this.serialNumber)
        .then(response => {
          this.setData(response.data)
        })
        .catch(error => {
          this.$notification.error({
            placement: 'bottomRight',
            message: 'Errors',
            description: error.message,
            style: { 'z-index': 1021, color: 'red' }
          })
        })
        .finally(() => {
          this.searching = false
          this.serialNumber = ''
          this.$refs.search.focus()
        })
    },
    setData(product) {
      let localState = this.model.product_detail.find(
        p => p.product_id === product.product_id
      )
      if (localState != undefined) {
        // check if serial number already added
        let is_exists = _.includes(
          localState.serial_list.map(el => el.value),
          product.serial_no
        )
        if (is_exists) {
          this.$notification.error({
            placement: 'bottomRight',
            message: 'Error',
            description:
              'Serial Number: ' + product.serial_no + ' already added.',
            style: { 'z-index': 1021, color: '#135e5e' }
          })
        } else {
          localState.serial_list.push({
            value: product.serial_no,
            label: product.original_serial
          })

          this.$notification.info({
            placement: 'bottomRight',
            message: 'Info',
            description:
              'Serial Number: ' +
              product.serial_no +
              ' added to ' +
              product.product_name_en,
            style: { 'z-index': 1021, color: '#135e5e' }
          })
        }

        localState.quantity = localState.serial_list.length
      } else {
        this.$store.commit('wholesale/operation/SET_PRODUCT', {
          uom_cat_id: product.product.uom_cat_id,
          product_id: product.product_id,
          sale_code: product.sale_codes,
          uom_category: product.product.uom_category,
          vat_eligible: product.vat_eligible
        })
        let price = this.getSalePrice({
          product_id: product.product_id,
          uom_id: product.uom_id
        })
        this.model.product_detail.push({
          product_id: product.product_id,
          product_name_en: product.product_name_en,
          product_name_kh: product.product_name_kh,
          barcode: product.barcode,
          uom_id: product.uom_id,
          quantity: 1,
           amount_in_khr: _.round(price * this.khrRate, 4),
          // amount_in_bath: _.round(price * this.thbRate, 4),
          unit_price: price,
          discount_type: '%',
          discount_rate: 0,
          discount_amount: 0,
          total_after_discount: 0,
          vat_rate: 0,
          vat_amount: 0,
          grand_total: 0,
          promo_ref_promo_product_id: null,
          promo_type_id: null,
          serial_list: [
            {
              value: product.serial_no,
              label: product.original_serial
            }
          ],
          is_custom: false,
          has_serial: true,
          vat_eligible: product.vat_eligible,
          balance: 'N/A'
        })
      }
      this.$emit('calculate')
    }
    //
  },
  watch: {
    serialNumber: debounce(function(number) {
      if (number) {
        this.fetchSerial()
      }
    }, 500)
  }
}
</script>
